import { render, staticRenderFns } from "./NuevoCliente.vue?vue&type=template&id=6d62fada"
import script from "./NuevoCliente.vue?vue&type=script&lang=js"
export * from "./NuevoCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports